<div menuSystem [cerrixTab]="tab">
    <div [attr.name]="'Scheduler Status'" menuicon="fas fa-code" menusystemsubmenu>
        <div name="Job List" menuicon="fas fa-file-import" menusystemitem>
            <job-scheduler-list></job-scheduler-list>
        </div>
    </div>
</div>
